import { breakpoints } from '@bnnvara/breakpoints';
import { globalBorderRadius } from '@bnnvara/themes';
import styled from 'styled-components';
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${globalBorderRadius};
  margin: auto;
  margin-left: 0;

  ${breakpoints.md} {
    display: block;
    justify-content: normal;
    align-items: normal;
    background-color: ${({
  theme
}) => theme.base.white};
    padding: 0 20px;
    position: relative;
    height: 206px;
  }
`;
export const CardMeta = styled.div`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 0.8rem;
  font-weight: 500;
  color: ${({
  theme
}) => theme.secondary.light};
  background: ${({
  theme
}) => theme.base.white};
  z-index: 1;

  ${breakpoints.md} {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 20px 25px;
  }
`;
export const Subtitle = styled.p`
  display: block;
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 15px;
  line-height: 22px;
  color: ${({
  theme
}) => theme.base.black};
  margin-bottom: 25px;
  overflow: hidden;
`;
export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  background-color: ${({
  theme
}) => theme.base.white};

  span {
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 18px;
    font-weight: bold;
    line-height: 1.27;
    word-break: break-word;
    color: ${({
  theme
}) => theme.base.black};
    margin: 0 0 4px;
    display: inline-block;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 5px;
      width: 100%;
      height: 4px;
      background-color: ${({
  theme
}) => theme.primary.main};
      transform: scaleX(0);
      transition: all 0.2s ease-in-out;
      transform-origin: left center;
    }
  }

  &:hover {
    span {
      &:after {
        content: '';
        transform: scaleX(1);
        transform-origin: left center;
        transition: all 0.2s ease-in-out;
      }
    }
  }

  ${breakpoints.md} {
    border: 1px solid ${({
  theme
}) => theme.tertiary.main};
    border-top-width: 0px;
    border-radius: ${globalBorderRadius};
    flex-direction: column;
    justify-content: 'flex-end';

    span {
      font-size: 20px;
      margin: 16px 0 0;
      padding-bottom: 16px;
    }
  }

  ${breakpoints.lg} {
    span {
      font-size: 24px;
    }
  }
`;
export const CardImageContainer = styled.div`
  width: 112px;
  height: 96px;
  flex-shrink: 0;
  margin-right: 8px;

  ${breakpoints.md} {
    position: relative;
    padding-bottom: 56.2%;
    width: 100%;
    height: auto;
  }
`;
export const CardImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: ${globalBorderRadius} 0 0 ${globalBorderRadius};

  ${breakpoints.md} {
    position: absolute;
    border-radius: ${globalBorderRadius} ${globalBorderRadius} 0 0;
  }
`;
export const CardTag = styled.div`
  display: none;
  ${breakpoints.md} {
    display: block;
    margin: -29px 0 0 20px;
    z-index: 1;
  }
`;
export const Description = styled.p`
  display: none;

  ${breakpoints.md} {
    display: block;
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 15px;
    line-height: 22px;
    color: ${({
  theme
}) => theme.base.black};
    margin-bottom: 25px;
    overflow: hidden;
  }
`;